module.exports = __webpack_public_path__ + "img/10.379e18df.png";